import { RequestState } from "../../../types"
import { AddressSettingsAction } from "./actions"
import { AddressSettingsState } from "./store"

export const LOAD_TIMEZONES_REQUEST = 'LOAD_TIMEZONES_REQUEST'
export const LOAD_TIMEZONES_RECEIVED = 'LOAD_TIMEZONES_RECEIVED'
export const LOAD_TIMEZONES_ERROR = 'LOAD_TIMEZONES_ERROR'
export const LOAD_COUNTRIES_REQUEST = 'LOAD_COUNTRIES_REQUEST'
export const LOAD_COUNTRIES_RECEIVED = 'LOAD_COUNTRIES_RECEIVED'
export const LOAD_COUNTRIES_ERROR = 'LOAD_COUNTRIES_ERROR'
export const UPDATE_ADDRESS_SETTINGS_FIELD = 'UPDATE_ADDRESS_SETTINGS_FIELD'
export const LOAD_ADDRESS_REQUEST = 'LOAD_ADDRESS_REQUEST'
export const LOAD_ADDRESS_RECEIVED = 'LOAD_ADDRESS_RECEIVED'
export const LOAD_ADDRESS_ERROR = 'LOAD_ADDRESS_ERROR'
export const UPDATE_ADDRESS_REQUEST = 'UPDATE_ADDRESS_REQUEST'
export const UPDATE_ADDRESS_RECEIVED = 'UPDATE_ADDRESS_RECEIVED'
export const UPDATE_ADDRESS_ERROR = 'UPDATE_ADDRESS_ERROR'
export const UPDATE_ADDRESS_RESET = 'UPDATE_ADDRESS_RESET'

export function addressSettingsReducer(state: AddressSettingsState, action: AddressSettingsAction) {
  switch (action.type) {
    case LOAD_TIMEZONES_REQUEST: {
      return {
        ...state,
        timezonesRequestState: RequestState.Loading
      }
    }

    case LOAD_TIMEZONES_RECEIVED: {
      return {
        ...state,
        timezones: action.timezones,
        timezonesRequestState: RequestState.Loaded
      }
    }

    case LOAD_TIMEZONES_ERROR: {
      return {
        ...state,
        timezonesRequestState: RequestState.Error
      }
    }

    case LOAD_COUNTRIES_REQUEST: {
      return {
        ...state,
        countriesRequestState: RequestState.Loading
      }
    }

    case LOAD_COUNTRIES_RECEIVED: {
      return {
        ...state,
        countries: action.countries,
        countriesRequestState: RequestState.Loaded
      }
    }

    case LOAD_COUNTRIES_ERROR: {
      return {
        ...state,
        countriesRequestState: RequestState.Error
      }
    }

    case UPDATE_ADDRESS_SETTINGS_FIELD: {
      return {
        ...state,
        address: {
          ...state.address,
          [action.field]: action.value
        }
      }
    }

    case LOAD_ADDRESS_REQUEST: {
      return { 
        ...state,
        addressRequestState: RequestState.Loading
      }
    }

    case LOAD_ADDRESS_RECEIVED: {
      return {
        ...state,
        address: action.address,
        noAddress: action.noAddress,
        addressRequestState: RequestState.Loaded
      }
    }

    case LOAD_ADDRESS_ERROR: {
      return {
        ...state,
        addressRequestState: RequestState.Error
      }
    }
    
    case UPDATE_ADDRESS_REQUEST: {
      return {
        ...state,
        updateRequestState: RequestState.Loading
      }
    }

    case UPDATE_ADDRESS_RECEIVED: {
      return {
        ...state,
        updateRequestState: RequestState.Loaded
      }
    }

    case UPDATE_ADDRESS_ERROR: {
      return {
        ...state,
        updateRequestState: RequestState.Error
      }
    }

    case UPDATE_ADDRESS_RESET: {
      return {
        ...state,
        updateRequestState: RequestState.NotLoaded
      }
    }

    default: {
      return state
    }
  }
}
